import { BaseError } from "./error-base";

type ErrorName = 
    | 'CREATE_ORGANIZATION_ERROR'
    | 'CREATE_PERSONNEL_ERROR'
    | 'CREATE_FLEET_ERROR'
    | 'CREATE_NETWORK_ERROR'
    | 'CREATE_EQUIPMENT_ERROR'
    | 'CREATE_INFRASTRUCTURE_ERROR'
    | 'CREATE_ROLE_ERROR'
    | 'DELETE_ORGANIZATION_ERROR'
    | 'DELETE_PERSONNEL_ERROR'
    | 'DELETE_FLEET_ERROR'
    | 'DELETE_NETWORK_ERROR'
    | 'DELETE_EQUIPMENT_ERROR'
    | 'DELETE_INFRASTRUCTURE_ERROR'
    | 'DELETE_ROLE_ERROR'
    | 'FETCH_ORGANIZATION_ERROR'
    | 'FETCH_PERSONNEL_ERROR'
    | 'FETCH_FLEET_ERROR'
    | 'FETCH_NETWORK_ERROR'
    | 'FETCH_EQUIPMENT_ERROR'
    | 'FETCH_INFRASTRUCTURE_ERROR'
    | 'FETCH_ROLE_ERROR'
    | 'FETCH_LANGUAGES_ERROR'
    | 'UPDATE_ORGANIZATION_ERROR'
    | 'UPDATE_PERSONNEL_ERROR'
    | 'UPDATE_FLEET_ERROR'
    | 'UPDATE_NETWORK_ERROR'
    | 'UPDATE_EQUIPMENT_ERROR'
    | 'UPDATE_INFRASTRUCTURE_ERROR'
    | 'UPDATE_ROLE_ERROR'
    | 'EQUIPMENT_ALREADY_ASSIGNED_ERROR'

export class ResourceError extends BaseError<ErrorName> {}